import { StackScreenProps } from "@react-navigation/stack";
import { ActionCreateInvoiceSaleRootParamList } from "../../../../types";
import { Button, Page, Stack } from "@towersystems/roam-common-native";
import { CustomerCard } from "../../components/CustomerCard";
import { useTranslation } from "../../../../utilities/i18n";
import { Colors } from "react-native-ui-lib";
import {
  useParkSale,
  useSaleControllerProvider,
} from "../../utils/sale-controller";
import React from "react";
import { SaleState } from "../../../../utilities/data/model/Sale";
import { ActionCreateInvoiceSaleRootScreenProps } from "../ActionCreateInvoiceSaleRootScreen";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";

export interface ConfirmInvoiceDetailsScreenProps
  extends StackScreenProps<
    ActionCreateInvoiceSaleRootParamList,
    "ConfirmInvoiceDetailsScreen"
  > {}

export const ConfirmInvoiceDetailsScreen = ({
  navigation,
  route,
}: ConfirmInvoiceDetailsScreenProps) => {
  const { sale, createEmptySale } = useSaleControllerProvider();
  const { t } = useTranslation("pos");
  const { customerId } = route.params;
  const parkSale = useParkSale();

  const handleOnCreateInvoice = React.useCallback(async () => {
    try {
      if (sale) {
        await parkSale();
      }
      const newSale = await createEmptySale();
      await newSale.addCustomer(customerId);
      await newSale.transitionToState(SaleState.INVOICE_OPEN);
      // The parent will be nested within a stack navigator,
      // so we need to pop twice to go back to the previous screen
      navigation
        .getParent<ActionCreateInvoiceSaleRootScreenProps["navigation"]>()
        .getParent<NativeStackNavigationProp<any>>()
        .pop();
    } catch (err) {
      console.log(err);
    }
  }, [sale]);

  const footerMarkup = (
    <Button
      disabled={false}
      label={t("button.create_invoice")}
      onPress={handleOnCreateInvoice}
      backgroundColor={Colors.action}
      color="white"
    ></Button>
  );

  return (
    <Page title={t("invoice_details")} footer={footerMarkup}>
      <Stack vertical>
        <CustomerCard customerId={customerId} />
      </Stack>
    </Page>
  );
};
